var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCusTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.684 7.86329V5.83171C14.684 5.27942 14.2363 4.83171 13.684 4.83171H9.03507C8.76985 4.83171 8.5155 4.72635 8.32796 4.53881L7.39796 3.60881C7.21042 3.42127 6.95607 3.31592 6.69085 3.31592H2.7998C2.24752 3.31592 1.7998 3.76363 1.7998 4.31592V13.6843C1.7998 14.2366 2.24752 14.6843 2.7998 14.6843H3.43193C3.78625 14.6843 4.07349 14.3971 4.07349 14.0428V14.0428C4.07349 13.9659 4.08733 13.8895 4.11434 13.8175L6.10384 8.51216C6.25021 8.12186 6.62333 7.86329 7.04017 7.86329H14.8124C15.4949 7.86329 15.9769 8.53198 15.7611 9.17952L14.154 14.0006C14.0179 14.4089 13.6358 14.6843 13.2054 14.6843H3.31559",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCusTemplates);
export default __webpack_public_path__ + "static/media/IconCusTemplates.cedd827adf3fe88041ad0ef35e9dd5af.svg";
export { ForwardRef as ReactComponent };